import { Injectable } from '@angular/core';

@Injectable()
export class DomService {
  constructor() {}

  /**
   * This brings the scroll position of particular element somewhere in middle of the page/container.
   *
   * @return { void }
   * @memberof DomService
   */
  scrollViewIntoMiddle(element: HTMLElement, parentContainerSelector?: string): void {
    if (!element) {
      return;
    }

    const parent = parentContainerSelector
      ? document.querySelector(parentContainerSelector)
      : element.parentElement;
    if (!parent) {
      return;
    }

    const elementRect = element.getBoundingClientRect();
    const absoluteElementTop = elementRect.top + parent.scrollTop;
    const middle =
      absoluteElementTop -
      (parentContainerSelector ? parent.clientHeight / 2 : parent.clientHeight);
    parent.scrollTo(0, middle);
  }
}
